import { render, staticRenderFns } from "./mallDetails.vue?vue&type=template&id=4345aefc&scoped=true&"
import script from "./mallDetails.vue?vue&type=script&lang=js&"
export * from "./mallDetails.vue?vue&type=script&lang=js&"
import style0 from "./mallDetails.vue?vue&type=style&index=0&id=4345aefc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4345aefc",
  null
  
)

export default component.exports